import { defineComponent as a, openBlock as i, createBlock as l, unref as n, mergeProps as r, withCtx as f, renderSlot as u } from "vue";
import o from "./ghl-ui.es367.js";
const s = a({
  name: "UISpace",
  inheritAttrs: !1
}), c = a({
  ...s,
  props: {
    align: {
      type: String,
      default: void 0
    },
    inline: {
      type: Boolean,
      default: !1
    },
    wrapItem: {
      type: Boolean,
      default: !0
    },
    justify: {
      type: String,
      default: "start"
    },
    size: {
      type: String,
      default: "medium"
    },
    vertical: {
      type: Boolean,
      default: !1
    },
    wrap: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    return (t, d) => (i(), l(n(o), r(t.$attrs, {
      align: e.align,
      inline: e.inline,
      "wrap-item": e.wrapItem,
      justify: e.justify,
      size: e.size,
      vertical: e.vertical,
      wrap: e.wrap
    }), {
      default: f(() => [
        u(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["align", "inline", "wrap-item", "justify", "size", "vertical", "wrap"]));
  }
}), y = c;
export {
  y as default
};
